import { TransactionType } from '../../transaction/enums/transaction-type.enum';
import { FeeCalculationType } from '../enums/fee-calculation-type.enum';
import { FeeType } from '../enums/fee-type.enum';
import { PaymentType } from '../enums/payment-type.enum';
import { RateType } from '../enums/rate-type.enum';

export interface IFee {
  rateType: RateType;
  type: FeeType;
  paymentType: PaymentType;
  transactionType: TransactionType[] | TransactionType;
  calculationType: FeeCalculationType;
  value: string;

  // Derived fields
  formattedType?: string;
  formattedRateType?: string;
  formattedTransactionType?: string[] | string;
  formattedPaymentType?: string[] | string;
}
